import apiClient from "../api/axiosConfig";

export const createMetadata = async (collection, request) =>
    apiClient.feesAPI.post(`/api/v1/metadata/create/${collection}`, request);

export const updateMetadataCollection = async (collection, request) =>
    apiClient.feesAPI.put(`/api/v1/metadata/collection/update`, request);

export const getCollections = async () =>
    apiClient.feesAPI.get(`/api/v1/metadata/collections`);

export const getMetadata = async (collection) =>
    apiClient.feesAPI.get(`/api/v1/metadata/${collection}`);

export const updateMetadata = async (collection, request) =>
    apiClient.feesAPI.put(`/api/v1/metadata/update/${collection}`, request);

export const createMetadataCollection = async (request) =>
    apiClient.feesAPI.post(`/api/v1/metadata/collection/create`, request);
